export const CHAT_TIME_FORMAT = 'kk:mm'
export const CHAT_DATE_FORMAT = 'ddd,D MMM YY'
export const MAX_TEXT_LENGTH = 20 //characters
export const MAX_VNOTE_TIME = 20 //seconds
export const MAX_VINTRO_TIME = 20 //seconds
export const DOB_FORMAT = 'DD/MM/YYYY'
export const ANONYMOUS = 'anonym'
export const ONLINE = 'online'
export const OFFLINE = 'offline'
export const FCM_KEY = 'BNlBUbgvpgNeNMSMsb8Dzei0luHDi4hgiZKP1zyXWLKXbzx0LFNlNkHD694q7M01KMBSTv5dWGXpA9s1AJUx6EM'
export const GOOGLE_CLIENT_ID = '1055029363345-620db7j1erat535c9ms7sjr4u20a4985.apps.googleusercontent.com'

export const appConfig = {
    MQTT_URL : 'wss://broker.emqx.io:8084/mqtt',
    MQTT_BASE: 'hearme/xcvghuiokjm',
    MQTT_PRIVATE: 'private',
    MQTT_PUBLIC: 'public',
    MQTT_CHAT: 'chat',
    MQTT_STATUS: 'status',
    IM_TEXT_LENGTH: 160,
    BIO_LENGTH: 160,
    DUMMY_IMG_URL : '',
    APP_NAME: 'SayToMe'

}

//App Screen Pages links
export const Pages = {
    IM_CHATS: '/stapp/imchats',
    IM_CHATBOX: '/stapp/imchat',
    DUMP_PLAYGROUND : '/stapp/dumpPlayground'
}

//https://images.pexels.com/photos/731022/pexels-photo-731022.jpeg
